import React from "react";
import styled from "styled-components/macro";
import { useBreakpoint } from "../../utilities/media-js-breakpoints";
import CustomScrollbar from "../CustomScrollbar/CustomScrollbar";

const ImagesContainer = styled.div<ImageContainerProps>`
    ${({ theme }) => theme.bp.xs`
        position: relative;
        overflow-x: auto;
        pointer-events: auto;
        justify-content: flex-start;
    `};
    ${({ theme, fullscreen }) =>
        fullscreen
            ? theme.bp.xs`
        height: 100%;
        overflow-x: hidden;
    `
            : theme.bp.xs`
        height: 50%;
    `};
    ${({ theme }) => theme.bp.sm`
        overflow-x: hidden;
        width: unset;
        justify-content: center;
    `};
    ${({ theme }) => theme.bp.md`
        height: 100%;
    `};
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    width: 100vw;
`;

const Overlay = styled.div`
    pointer-events: none;
    position: absolute;
    height: 100%;
    width: 100vw;
    z-index: 1;
    background: rgba(0, 0, 0, 0)
        linear-gradient(
            0deg,
            rgba(0, 0, 0, 0.5) 0px,
            rgba(0, 0, 0, 0.4) 20px,
            rgba(0, 0, 0, 0.15) 70px,
            rgba(0, 0, 0, 0) 150px
        )
        repeat scroll 0% 0%;
`;

interface ImageContainerProps {
    fullscreen: boolean;
}

export const ConfigImageContainer = ({
    imageWidth,
    imageHeight,
    fullscreen,
    withDesktopGradientOverlay,
    children,
}: {
    imageWidth: number | undefined;
    imageHeight: number | undefined;
    fullscreen?: boolean;
    withDesktopGradientOverlay?: boolean;
    children: React.ReactNode;
}) => {
    const breakpoints = useBreakpoint();
    const isMobile = breakpoints.xxs || breakpoints.xs || breakpoints.sm;
    const centerImage = (imageWidth || 0) / window.devicePixelRatio < window.innerWidth;
    let containerStyle = {};
    if (centerImage) {
        containerStyle = {
            display: "flex",
            justifyContent: "center",
            height: "100%",
            marginRight: isMobile ? "17px" : "",
        };
    } else if (breakpoints.xs || breakpoints.xxs) {
        containerStyle = { height: "100%" };
    } else {
        containerStyle = { display: "flex", justifyContent: "center", alignItems: "center", height: "100%" };
    }

    const content = <div style={containerStyle}>{children}</div>;
    return (
        <ImagesContainer
            style={{
                height: breakpoints.portrait && isMobile ? "50%" : "100%",
            }}
            fullscreen={fullscreen || false}
        >
            {isMobile ? (
                <CustomScrollbar
                    maxHeight="100%"
                    renderHorizontal={!fullscreen && !breakpoints.sm}
                    renderVertical={false}
                >
                    {content}
                </CustomScrollbar>
            ) : (
                <>
                    {withDesktopGradientOverlay ? <Overlay /> : null}
                    {content}
                </>
            )}
        </ImagesContainer>
    );
};
